// import '../../styles/Navbar.css'
import { Fragment, useMemo, useEffect, useRef, useState } from "react";
import { useMap, useMapEvents } from "react-leaflet";
import { useDispatch, useSelector } from 'react-redux';
import { createPortal } from "react-dom";
import { setFilter } from "../../store/reducers/stateReducer";
import { motion } from "framer-motion";
import { setLayers } from "../../store/reducers/helpersReducer";
import '../../styles/TagCloud.css';
import '../../styles/StatementsControl.css';
import { aimToObject, addPulseMarker } from './helpers';
import { Box, Paper, styled, Switch, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow, Tooltip, Typography, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import UpdateIcon from '@mui/icons-material/Update';
import { ktpIcon, pillarIcon } from "../layers/icons";
import { selectAccountingsApplyChecklist, selectAccountingsApplyDial, selectAccountingsFiltered, selectAccountingsGroupedByKtp, selectAccountingsGroupedByTowns, selectAccountingsGroupedByTownsNew, selectAccountingsGroupedByTownsNoChecklist, selectRulesMap } from "../../store/selectors/supervisionSelector";
import { codeColors, getStatusIcon, statuses } from "../contents/AccountingSheetView";

function formatDate(date) {
    return `${new Date(date).toLocaleTimeString()} ${new Date(date).toLocaleDateString()}`
}

function sortDateStrings(arr) {
    return arr.slice().sort((a, b) => {
        // Разбиваем строку на компоненты даты и времени
        const parseDate = (str) => {
            const [timePart, datePart] = str.split(' ');
            const [day, month, year] = datePart.split('.').map(Number);
            const [hours, minutes] = timePart.split(':').map(Number);

            // Создаем объект Date (месяцы в JS начинаются с 0)
            return new Date(year, month - 1, day, hours, minutes);
        };

        // Сравниваем временные метки
        return parseDate(b.accounting.created) - parseDate(a.accounting.created);
    });
}

const colorMap = {
    'pillar04': '#0302D9',
    'pillar04_accounting_ready': '#2196F3',
    'pillar04_accounting_completed': '#00df00',
    'pillar04_accounting_not_completed': '#ff0000',
    'pillar04_accounting_half_completed': '#ffc000',
    'pillar04_accounting_rejected': '#9C27B0',
}

const translate = {
    'Устранено': 'completed',
    'Готово к проверке': 'ready',
    'Отклонено': 'rejected',
    'Устранено частично': 'half_completed',
    'Частично устранено': 'half_completed',
    'Не устранено': 'not_completed',
    'Актуальные': 'actual',
    'Отобразить всё': 'all'
}


const StatementsControl = (props) => {
    const map = useMap();
    const dispatch = useDispatch();
    const [isHover, setIsHover] = useState(false)
    const [isIconHover, setIsIconHover] = useState(null)
    const [isHidden, setIsHidden] = useState(false)
    const [textSearch, setTextSearch] = useState('')
    const [f, setF] = useState(null)
    const t = useRef(null)
    // const [isExtendedNames, setIsExtendedNames] = useState(null)
    const test = useRef()
    // const [isFiltering, setIsFiltering] = useState(false)
    const [state, setState] = useState(localStorage.getItem('accountingControl') ? JSON.parse(localStorage.getItem('accountingControl')) : {
        hidden: false,
        accordions: []
    })

    const [accounting, setAccounting] = useState(null)
    const [accountingF, setAccountingF] = useState(null)

    const accountingTownsFiltered = useSelector(selectAccountingsGroupedByTownsNew);
    const rules = useSelector(selectRulesMap)
    console.log(accountingTownsFiltered)

    const [tagCloud, setTagCloud] = useState(false)
    const [history, setHistory] = useState(localStorage.getItem('statementsHistory') ? JSON.parse(localStorage.getItem('statementsHistory')) : false)

    useEffect(() => {
        localStorage.setItem('statementsHistory', JSON.stringify(history))
    }, [history])

    useEffect(() => {
        setAccounting(accountingTownsFiltered)
    }, [accountingTownsFiltered])

    useEffect(() => {

        localStorage.setItem('accountingControl', JSON.stringify(state))

    }, [state])

    useMapEvents({
        'signal:drawing': (e) => {
            console.log(e)

            if (window.innerWidth < 768 && e.source === 'print') {
                setIsHidden(e.state)
            }
        }


    })

    useEffect(() => {
        if (textSearch) {
            let ids = new Set()
            const searchWords = textSearch.toLowerCase().split(/\s+/).filter(word => word.length > 0);
            setAccountingF(accounting.map(acc => {
                let tps = acc.tps
                tps = tps.map(tp => {

                    const pillars = tp.pillars.filter(pillar => {
                        if (!searchWords.every(word =>
                            [acc.town, tp.name, acc.ps.name, acc.ps.operating_voltage, pillar.name, 'id', pillar.accounting.id, pillar.accounting.created, pillar.accounting.instructions, pillar.accounting.retreat_psd].join(' ').toLocaleLowerCase().includes(word.toLocaleLowerCase())
                        )) return null
                        return pillar
                    }).filter(f => f)

                    pillars.map(p => ids.add(p.fid))
                    return {
                        ...tp,
                        pillars: pillars,
                        count: pillars.length
                    }
                })
                return {
                    ...acc,
                    tps: tps,
                    count: tps.reduce((t, r) => t + r.count, 0)
                }
            }))
            setF([...ids])
        } else {
            setAccountingF(accounting)
            setF(null)
        }

    }, [accounting, textSearch])



    function selectHost(host, layer = null) {
        // console.log(host)
        if (host) {


            if (window.innerWidth < 768) {
                // dispatch(setAccountingControlHidden(true))
                setState((p) => { return { ...p, hidden: true } })
            }
            // map.panTo([
            //     host.x_y_coord.split(' ')[1],
            //     host.x_y_coord.split(' ')[0],
            // ], 16, { duration: 1, animate: false })
            if (host.coords) {
                map.setView(host.coords, 18, { duration: 1, animate: false })
            } else {
                map.setView([
                    host.x_y_coord.split(' ')[1],
                    host.x_y_coord.split(' ')[0],
                ], 18, { duration: 1, animate: false })
            }

            map.eachLayer(function (layer) {
                layer.closeTooltip()
            })
            dispatch(setLayers({ layer: layer, position: 1 }))
            setTimeout(() => {

                map.closePopup()

                map.eachLayer(function (layer) {
                    if (layer.options.data === host.fid) {
                        layer.openTooltip()
                        addPulseMarker(map, layer)
                    }
                    // else {
                    //     setTimeout(() => {
                    //         map.eachLayer(function (layer) {
                    //             if (layer.options.data === host.fid) {
                    //                 layer.openTooltip()
                    //                 addPulseMarker(map, layer)
                    //             }
                    //         })
                    //     }, 500)
                    // }
                })
            }, 500)
        }
    }


    function aimtospillars(hosts) {
        // console.log(hosts)
        let minx = 100;
        let maxx = 0;
        let miny = 100;
        let maxy = 0;
        hosts.map(t => {
            const x = parseFloat(t.x_y_coord ? t.x_y_coord.split(' ')[1] : t.coords[0])
            const y = parseFloat(t.x_y_coord ? t.x_y_coord.split(' ')[0] : t.coords[1])
            minx = x < minx ? x : minx
            maxx = x > maxx ? x : maxx
            miny = y < miny ? y : miny
            maxy = y > maxy ? y : maxy
        })
        if (minx !== 100) {
            if (window.innerWidth < 768) {
                setState((p) => { return { ...p, hidden: true } })
            }
            const layers = new Set(hosts.map(h => h.type))
            dispatch(setLayers(Array.from(layers).map(l => ({ layer: l, position: 1 }))))
            map.flyToBounds([[minx, miny], [maxx, maxy]], { maxZoom: 18, animate: false })
        }
    }

    return (
        createPortal(
            <Box sx={{
                order: 2,
                zIndex: 1200,
                display: isHidden ? 'none' : 'flex',
                flexDirection: 'column',
                borderRadius: window.innerWidth > 768 ? '5px' : '3px',
                maxHeight: 'calc(100vh - 400px)',
                pointerEvents: 'auto',
                width: window.innerWidth > 768 ? '600px' : '300px', // 600 * 0.7 = 420
                maxWidth: window.innerWidth > 768 ? '600px' : '300px',
                height: 'fit-content',
                fontSize: window.innerWidth > 768 ? '14px' : '10px',
                '& *': {
                    fontSize: 'inherit'
                    // убираем transform: scale()
                }
            }}>
                {
                    tagCloud && window.innerWidth <= 768 ? <TagCloud /> : null
                }
                <Box key={"header"} style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    cursor: 'pointer',
                    // padding: '2px',
                    color: 'rgb(214, 214, 214)',
                    backgroundColor: 'rgb(36, 36, 36)',
                    height: window.innerWidth > 768 ? '34px' : '26px',
                    // opacity: isHover ? '1' : '0.7',
                    borderTopLeftRadius: window.innerWidth > 768 ? '5px' : '3px',
                    borderTopRightRadius: window.innerWidth > 768 ? '5px' : '3px',
                    borderBottomLeftRadius: state.hidden ? (window.innerWidth > 768 ? '5px' : '3px') : '0px',
                    borderBottomRightRadius: state.hidden ? (window.innerWidth > 768 ? '5px' : '3px') : '0px',
                    boxShadow: '0px 2px 6px grey',
                    fontSize: window.innerWidth > 768 ? '16px' : '13px',
                   
                }}>
                    <div key={"title"} style={{ marginLeft: window.innerWidth > 768 ? '5px' : '3px', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <span onClick={() => setState((p) => { return { ...p, hidden: !state.hidden } })}>Предписания</span>

                    </div>
                    <div key={"search"} style={{ position: 'relative', display: 'flex', alignItems: 'center', width: '100%', margin: '0 20px' }}>
                        <input type="text" id="searchInput" placeholder="Поиск" style={{ height: '60%', width: '100%', border: "1px solid #ccc", borderRadius: "4px", padding: window.innerWidth > 768 ? '2px 5px' : '1px 3px', margin: '0 10px', outline: 'none' }}
                            onChange={e => setTextSearch(e.target.value)}
                            value={textSearch}
                        />
                        {textSearch &&
                            <button className='clear-input-button' onClick={e => setTextSearch('')}>
                                <span className="material-icons" style={{ fontSize: 'inherit' }}>close</span>
                            </button>
                        }
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <div key={"history"} style={{ marginRight: window.innerWidth > 768 ? '5px' : '3px', backgroundColor: isIconHover ? 'rgb(145, 145, 145)' : '', borderRadius: window.innerWidth > 768 ? '5px' : '3px', display: 'flex', alignItems: 'center' }}
                            onClick={() => setHistory(!history)}
                        >
                            <span className="material-symbols-outlined" id="history-expand-icon" style={{ fontSize: window.innerWidth > 768 ? '20px' : '16px' }}>history</span>
                        </div>

                        <div key={"tagcloud"} style={{ marginRight: window.innerWidth > 768 ? '5px' : '3px', backgroundColor: isIconHover ? 'rgb(145, 145, 145)' : '', borderRadius: window.innerWidth > 768 ? '5px' : '3px', display: 'flex', alignItems: 'center' }}
                            onClick={() => setTagCloud(!tagCloud)}
                        >
                            <span className="material-symbols-outlined" id="tagcloud-expand-icon" style={{ fontSize: window.innerWidth > 768 ? '20px' : '16px' }}>grain</span>
                        </div>
                        <div key={"close"} style={{ marginRight: window.innerWidth > 768 ? '5px' : '3px', backgroundColor: isIconHover ? 'rgb(145, 145, 145)' : '', borderRadius: window.innerWidth > 768 ? '5px' : '3px', display: 'flex', alignItems: 'center' }}
                            onClick={() => setState((p) => { return { ...p, hidden: !state.hidden } })}
                        >
                            <span className="material-symbols-outlined" id="statements-expand-icon" style={{ fontSize: window.innerWidth > 768 ? '20px' : '16px' }}>more_down</span>
                        </div>
                    </div>

                </Box>

                {
                    state && state.hidden ? <></> :
                        <div key={"body"} style={{
                            background: "white",
                            justifyContent: 'left',
                            overflowY: 'auto',
                            color: 'rgb(214, 214, 214)',
                            scrollbarColor: 'rgb(36, 36, 36)',
                            scrollbarWidth: 'thin',
                            backgroundColor: 'rgb(36, 36, 36)',
                            borderBottomLeftRadius: '5px',
                            borderBottomRightRadius: '5px',
                            // opacity: isHover ? '1' : '0.7'
                        }} className="statements-control-body">
                            <div key={"body_group"} ref={test} style={{ display: 'flex', flexDirection: 'column', backgroundColor: 'rgb(36, 36, 36)', padding: '10px' }}>
                                <div key={"body_group_header"} style={{ display: 'flex', justifyContent: 'space-between' }}>

                                    <div key={"body_group_em"} style={{ marginBottom: '5px', fontWeight: 'bold' }}>{accountingF && accountingF.length > 0 ? 'Предписания - ' + accountingF.reduce((t, r) => t + r.count, 0) : 'Предписаний нет'}</div>

                                </div>
                                {
                                    accountingF && accountingF.length > 0 ?
                                        accountingF.map((acc, i) => {
                                            if (acc.count === 0) return null
                                            return (
                                                <details key={`details_town_${i}`}
                                                    open={state.accordions && state.accordions.includes(`details_town_${i}`)}
                                                    onToggle={(e) => {
                                                        if (e.currentTarget.open) {
                                                            setState((p) => { return { ...p, accordions: !state.accordions.find(a => a === `details_town_${i}`) ? [...p.accordions, `details_town_${i}`] : p.accordions } })
                                                        } else {
                                                            setState((p) => { return { ...p, accordions: p.accordions.filter(acc => acc !== `details_town_${i}`) } })
                                                        }
                                                    }}
                                                >
                                                    <summary key={`summary_town_${i}`} >
                                                        <span key={`summary_town_${i}_icon`} className="material-icons" id="themeIcon" style={{ fontSize: 'inherit' }}>share_location</span>
                                                        <span key={`summary_town_${i}_label`} style={{ marginLeft: '4px', cursor: 'pointer' }}>{acc.town} - {acc.count}</span>

                                                    </summary>
                                                    {
                                                        acc.tps.map((trans, j) => {

                                                            if (trans.count === 0) return null
                                                            return <details key={`details_tp_${i}_${j}`} style={{ marginLeft: '12px' }}
                                                                open={state.accordions && state.accordions.includes(`details_tp_${i}_${j}`)}
                                                                onToggle={(e) => {
                                                                    if (e.currentTarget.open) {
                                                                        setState((p) => { return { ...p, accordions: !state.accordions.find(a => a === `details_tp_${i}_${j}`) ? [...p.accordions, `details_tp_${i}_${j}`] : p.accordions } })
                                                                    } else {
                                                                        setState((p) => { return { ...p, accordions: p.accordions.filter(acc => acc !== `details_tp_${i}_${j}`) } })
                                                                    }
                                                                }}
                                                            >
                                                                <summary key={`details_tp_${j}`}>
                                                                    <Box
                                                                        sx={{ display: 'contents', cursor: 'pointer', pointerEvents: 'auto' }}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation()
                                                                            aimToObject(map, trans.tp)
                                                                        }}
                                                                    >
                                                                        {ktpIcon('accounting', window.innerWidth < 768 ? 14 : 20, window.innerWidth < 768 ? 14 : 20)}
                                                                    </Box>
                                                                    {/* <svg width="2.1997359mm" height="5.1981357mm" viewBox="0 0 3.3997359 7.3981357" version="1.1" id="svg1">
                                                                        <defs id="defs1" />
                                                                        <g id="layer1" transform="translate(-76.835657,-126.54452)">
                                                                            <g strokeOpacity="1" transform="matrix(0.08464545,0,0,0.08464545,-19.793708,95.795296)" fontSize="54.1667px" strokeWidth="4.72441" fontStyle="normal" stroke="#cc0000" strokeLinejoin="bevel" fontWeight="400" fontFamily="'.AppleSystemUIFont'" fillOpacity="0.501961" fill="#ff0000" strokeLinecap="square" id="g6853" style={{ fillRule: 'evenodd' }}>
                                                                                <path vectorEffect="none" d="m 1179.38,430.594 c 0,9.784 -7.94,17.716 -17.72,17.716 -9.78,0 -17.72,-7.932 -17.72,-17.716 0,-9.785 7.94,-17.717 17.72,-17.717 9.78,0 17.72,7.932 17.72,17.717" fillRule="evenodd" id="path6852" />
                                                                            </g>
                                                                            <g strokeOpacity="1" transform="matrix(0.08464545,0,0,0.08464545,-19.793708,95.795296)" fontSize="54.1667px" strokeWidth="4.72441" fontStyle="normal" stroke="#cc0000" strokeLinejoin="bevel" fontWeight="400" fontFamily="'.AppleSystemUIFont'" fillOpacity="0.501961" fill="#ff0000" strokeLinecap="square" id="g6854" style={{ fillRule: 'evenodd' }}>
                                                                                <path vectorEffect="none" d="m 1179.38,406.972 c 0,9.784 -7.94,17.716 -17.72,17.716 -9.78,0 -17.72,-7.932 -17.72,-17.716 0,-9.785 7.94,-17.717 17.72,-17.717 9.78,0 17.72,7.932 17.72,17.717" fillRule="evenodd" id="path6853" />
                                                                            </g>
                                                                            <g strokeOpacity="1" transform="matrix(0.08464545,0,0,0.08464545,-19.793708,95.795296)" fontSize="54.1667px" strokeWidth="4.72441" fontStyle="normal" stroke="#cc0000" strokeLinejoin="bevel" fontWeight="400" fontFamily="'.AppleSystemUIFont'" fill="none" strokeLinecap="square" id="g6855" style={{ fillRule: 'evenodd' }}>
                                                                                <path vectorEffect="none" d="m 1161.66,365.633 v 23.622" fillRule="evenodd" id="path6854" />
                                                                            </g>
                                                                        </g>
                                                                    </svg> */}
                                                                    <span style={{ marginLeft: window.innerWidth > 768 ? '5px' : '3px', marginRight: window.innerWidth > 768 ? '5px' : '3px', cursor: 'pointer' }}>{acc.ps ? acc.ps.name + ' ' + acc.ps.operating_voltage + ' ' : ''}{trans.tp.name} - {trans.pillars.length}</span>
                                                                    {/* <svg width={16} height={16} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" style={{ margin: '0 3px 0 3px' }}
                                                                        // onClick={() => selectHost(trans.tp, 'transformers')}
                                                                        onClick={() => aimToObject(map, trans.tp)}
                                                                    >
                                                                        <path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
                                                                            fill='rgb(214, 214, 214)'
                                                                        />
                                                                    </svg> */}

                                                                    {/* <svg width={16} height={16} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{ margin: '0 3px 0 3px' }}
                                                                        onClick={() => aimtospillars([...trans.pillars, trans.tp])}>
                                                                        <path d="M256 0c17.7 0 32 14.3 32 32l0 34.7C368.4 80.1 431.9 143.6 445.3 224l34.7 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-34.7 0C431.9 368.4 368.4 431.9 288 445.3l0 34.7c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-34.7C143.6 431.9 80.1 368.4 66.7 288L32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l34.7 0C80.1 143.6 143.6 80.1 224 66.7L224 32c0-17.7 14.3-32 32-32zM128 256a128 128 0 1 0 256 0 128 128 0 1 0 -256 0zm128-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
                                                                            fill='rgb(214, 214, 214)'
                                                                        />
                                                                    </svg> */}
                                                                </summary>
                                                                {
                                                                    <table key={`table_${i}_${j}`} name='statements-table' id="statements-table" className={`statements-table`} style={{ verticalAlign: 'top' }}>
                                                                        <tbody id="table-body" style={{ verticalAlign: 'top' }}>
                                                                            {
                                                                                sortDateStrings(trans.pillars).map((pill, indx) => {
                                                                                    const hasChecklist = pill.accounting.checklist && pill.accounting.checklist.length > 0;
                                                                                    const rowCount = hasChecklist ? pill.accounting.checklist.length : 1;
                                                                                    return (<Fragment key={`${pill.fid}_${indx}_fragment`}>
                                                                                        <tr key={`${pill.fid}`} onClick={() => aimToObject(map, pill)}>
                                                                                            <td key={`${pill.fid}_header`} style={{ textAlign: 'left' }} colSpan={3}>
                                                                                                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'center' }}>
                                                                                                    {pillarIcon(pill.type, pill.status, pill.material_type, pill.supports_count, window.innerWidth < 768 ? 10 : 12)}
                                                                                                    {/* <svg fill="#000000" width="10px" height="10px" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 24 24">
                                                                                                    <circle r="50" cx="50" cy="50" fill={`var(--${pill.status})`} />
                                                                                                </svg> */}
                                                                                                    <Typography sx={{
                                                                                                        fontSize: { xs: '0.65rem', md: '0.85rem' },
                                                                                                        lineHeight: 1.1,
                                                                                                        marginLeft: window.innerWidth > 768 ? '5px' : '3px',
                                                                                                        cursor: 'pointer',
                                                                                                        whiteSpace: 'nowrap'
                                                                                                    }}
                                                                                                    >
                                                                                                        {pill.name} id{pill.accounting.id}
                                                                                                    </Typography>
                                                                                                </Box>
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr key={`${pill.fid}_${indx}`} style={{ lineHeight: 1.1 }}>
                                                                                            <td key={0} style={{ textAlign: 'left', display: 'flex', flexDirection: 'column', color: `var(--${pill.status})` }}>
                                                                                                <div style={{ display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'center', whiteSpace: 'nowrap' }}>
                                                                                                    <span className="material-icons" id="statements_icon">event</span>
                                                                                                    <Typography sx={{
                                                                                                        fontSize: { xs: '0.65rem', md: '0.85rem' },
                                                                                                        lineHeight: 1.1,
                                                                                                        verticalAlign: 'middle'
                                                                                                    }}
                                                                                                    >
                                                                                                        {pill.accounting.created}
                                                                                                    </Typography>
                                                                                                </div>
                                                                                            </td>
                                                                                            <td key={1} style={{ textAlign: 'left' }}>
                                                                                                <Typography sx={{
                                                                                                    fontSize: { xs: '0.65rem', md: '0.85rem' },
                                                                                                    lineHeight: 1.1,
                                                                                                }}>
                                                                                                    {hasChecklist ? `Опора ${pill.name} установлена с ${pill.accounting.checklist.length > 1 ? 'нарушениями:' : 'нарушением'}` : ''}
                                                                                                </Typography>
                                                                                            </td>
                                                                                            <td key={2} style={{ textAlign: 'center', color: `var(--${pill.status})` }}>
                                                                                                <div style={{ display: 'flex', flexDirection: 'row', gap: 1, justifyContent: 'center', alignItems: 'center', whiteSpace: 'nowrap' }}>
                                                                                                    {getStatusIcon(statuses[translate[pill.accounting.status]]?.icon, window.innerWidth < 768 ? 14 : 20)}
                                                                                                    <Typography sx={{
                                                                                                        fontSize: { xs: '0.65rem', md: '0.85rem' },
                                                                                                        lineHeight: 1.1,
                                                                                                    }}>{pill.accounting.status}</Typography>

                                                                                                </div>
                                                                                                {pill.accounting.status_date && (
                                                                                                    <div style={{ display: 'flex', flexDirection: 'row', gap: 1, justifyContent: 'center', alignItems: 'center', whiteSpace: 'nowrap' }}>
                                                                                                        <span className="material-icons" id="statements_icon" >event</span>
                                                                                                        <Typography sx={{
                                                                                                            fontSize: { xs: '0.65rem', md: '0.85rem' },
                                                                                                            lineHeight: 1.1,
                                                                                                            verticalAlign: 'middle'
                                                                                                        }}>
                                                                                                            {pill.accounting.status_date}
                                                                                                        </Typography>
                                                                                                    </div>
                                                                                                )}
                                                                                            </td>

                                                                                        </tr>
                                                                                        {hasChecklist ?
                                                                                            pill.accounting.checklist.map((ch, i) => {

                                                                                                const rule = rules[ch]
                                                                                                const isSuccess = pill.accounting.part_elimin_categ?.success?.includes(rule.code)
                                                                                                const isRejected = pill.accounting.part_elimin_categ?.rejected?.includes(rule.code)
                                                                                                const isReady = pill.accounting.part_elimin_categ?.ready?.includes(rule.code)
                                                                                                const statusLog = pill.accounting.status_log?.[ch];
                                                                                                const _statusLog = pill.accounting._status_log?.[ch];
                                                                                                console.log(statusLog)
                                                                                                return (
                                                                                                    <tr key={`rule_${pill.fid}_${rule.code}`} style={{ borderBottom: i !== rowCount - 1 ? '1px solid #666' : '1px solid #fff', lineHeight: 1.1 }}>
                                                                                                        <td key={0} style={{ textAlign: 'left', display: 'flex', gap: '5px' }}>
                                                                                                            <Typography sx={{
                                                                                                                fontSize: { xs: '0.65rem', md: '0.85rem' },
                                                                                                                lineHeight: 1.1,
                                                                                                                fontWeight: 'bold',
                                                                                                                color: `rgb(${codeColors[rule.code[0]] || [0, 0, 0]})`
                                                                                                            }}
                                                                                                            >
                                                                                                                {rule.code}
                                                                                                            </Typography>
                                                                                                            <Typography sx={{
                                                                                                                fontSize: { xs: '0.65rem', md: '0.85rem' },
                                                                                                                lineHeight: 1.1,
                                                                                                                color: `${isSuccess ? `var(--accounting_completed)` : isRejected ? `var(--accounting_rejected)` : isReady ? `var(--accounting_ready)` : ''}`
                                                                                                            }}
                                                                                                            >
                                                                                                                {rule.name}
                                                                                                            </Typography>
                                                                                                        </td>
                                                                                                        <td key={1} style={{ textAlign: 'left' }}>
                                                                                                            <Typography
                                                                                                                sx={{
                                                                                                                    fontSize: { xs: '0.65rem', md: '0.85rem' },
                                                                                                                    lineHeight: 1.1
                                                                                                                }}
                                                                                                            >
                                                                                                                {rule.description}

                                                                                                            </Typography>
                                                                                                        </td>
                                                                                                        <td key={2} style={{ textAlign: 'center' }}>
                                                                                                            {(statusLog?.ready || statusLog?.rejected) &&
                                                                                                                <Typography
                                                                                                                    sx={{
                                                                                                                        fontSize: { xs: '0.6rem', md: '0.7rem' },
                                                                                                                        color: statusLog?.rejected ? '#9C27B0' : '#2196F3',
                                                                                                                        lineHeight: 1.1
                                                                                                                    }}
                                                                                                                >
                                                                                                                    {_statusLog?.date} {_statusLog?.user?.short_fio} ({_statusLog?.user?.post_for_select})
                                                                                                                </Typography>
                                                                                                            }
                                                                                                            {(statusLog?.success) &&
                                                                                                                <Typography
                                                                                                                    sx={{
                                                                                                                        fontSize: { xs: '0.6rem', md: '0.7rem' },
                                                                                                                        color: '#48B349',
                                                                                                                        lineHeight: 1.1
                                                                                                                    }}
                                                                                                                >
                                                                                                                    {_statusLog?.date} {_statusLog?.user?.short_fio} ({_statusLog?.user?.post_for_select})
                                                                                                                </Typography>
                                                                                                            }
                                                                                                        </td>
                                                                                                        {/* {i === 0 &&
                                                                                                            <td rowSpan={rowCount} key={2} style={{ textAlign: 'center', color: 'var(--color-created)' }}>

                                                                                                                <div>
                                                                                                                    <span className="material-icons" id="statements_icon" >engineering</span>
                                                                                                                    <span style={{ verticalAlign: 'middle' }}>{pill.accounting.mark_completion_editor?.for_select || ''}</span>
                                                                                                                </div>
                                                                                                            </td>
                                                                                                        } */}
                                                                                                    </tr>
                                                                                                )
                                                                                            })
                                                                                            :
                                                                                            < tr key={`${pill.fid}_${indx}`} style={{ borderBottom: indx !== trans.pillars.length - 1 ? '1px solid white' : '', lineHeight: 1.1 }}>
                                                                                                <td key={0} style={{ textAlign: 'left', display: 'flex', flexDirection: 'column', color: `var(--${pill.status})` }}>

                                                                                                    <span>{pill.accounting.instructions}</span>
                                                                                                </td>
                                                                                                <td key={1} style={{ textAlign: 'left' }}>{pill.accounting.retreat_psd}</td>
                                                                                                <td key={2} style={{ textAlign: 'center', color: 'var(--color-created)' }}>

                                                                                                    <div>
                                                                                                        <span className="material-icons" id="statements_icon" >engineering</span>
                                                                                                        <span style={{ verticalAlign: 'middle' }}>{pill.accounting.mark_completion_editor?.for_select || ''}</span>
                                                                                                    </div>
                                                                                                </td>
                                                                                            </tr>
                                                                                        }
                                                                                    </Fragment>)
                                                                                })
                                                                            }
                                                                        </tbody>
                                                                    </table>
                                                                }
                                                            </details>
                                                        }).filter(f => f)
                                                    }


                                                </details>
                                            )
                                        }).filter(f => f)

                                        : null
                                }


                            </div>


                        </div>
                }

                {
                    tagCloud && window.innerWidth > 768 ? <TagCloud /> : null
                }
                {
                    history && <StatementsHistory />
                }
            </Box >
            // , window.innerWidth > 768 ? document.getElementById("map-controls-right-top") : document.getElementById("map-controls-right-bottom"))
            , document.getElementById(window.innerWidth < 768 ? "map-controls-left-bottom-first-row-right" : "map-controls-right-top"))

    )



}


// ---------- Данные и описания ----------
// const pTags = Array.from({ length: 10 }, (_, i) => `П${i + 1}`);
// const gTags = Array.from({ length: 10 }, (_, i) => `Г${i + 1}`);
// const sTags = Array.from({ length: 10 }, (_, i) => `С${i + 1}`);
// const tags = ["Все", ...pTags, ...gTags, ...sTags];
// const descriptions = Object.fromEntries(tags.map((t) => [t, t === "Все" ? "Показать все записи" : `Описание для ${t}`]));
// const data = Array.from({ length: 150 }, (_, i) => ({ id: i + 1, code: tags[Math.floor(Math.random() * (tags.length - 1)) + 1], name: `Объект ${i + 1}` }));

// ---------- Утилиты ----------
const defaultColor = [0, 0, 0]
const colors = { 'П': [147, 51, 234], 'Г': [16, 185, 129], 'С': [59, 130, 246], 'Р': [246, 34, 58], 'Ш': [255, 127, 39] };
const colorOf = (t, a = 1) => (t === "Все" ? `rgba(255,99,71,${a})` : !t ? `rgba(0,0,0,${a})` : `rgba(${colors[t[0]].join(",")},${a})`);
const spherePoints = (n, r) => {
    const res = [];
    const off = 2 / n;
    const inc = Math.PI * (3 - Math.sqrt(5));
    for (let i = 0; i < n; i++) {
        const y = i * off - 1 + off / 2;
        const d = Math.sqrt(1 - y * y);
        const phi = i * inc;
        res.push({ x: Math.cos(phi) * d * r, y: y * r, z: Math.sin(phi) * d * r });
    }
    return res;
};

const TagCloud = (props) => {
    const containerRef = useRef(null);
    const dispatch = useDispatch();
    // const [data, setData] = useState(["Все"]);
    // const [tags, setTags] = useState(["Все"]);
    const [descriptions, setDescriptions] = useState(["Показать все записи"]);
    const [through, setThrough] = useState(false)
    const [complexityFilter, setComplexityFilter] = useState('Все')

    // const { accountingTowns, accountingTownsFiltered, rules } = useSelector(
    //     (state) => state.state
    // );
    const rules = useSelector(state => state.state.rules)
    const rulesMap = useSelector(selectRulesMap)
    const accountings = useSelector(selectAccountingsApplyDial)
    // const filter = useSelector(state => state.state.filter)
    const accountingsFiltered = useSelector(selectAccountingsApplyChecklist)

    // выбранные теги
    const [selected, setSelected] = useState(["Все"]);

    // точки на сфере
    const [particles, setParticles] = useState([]);

    // углы вращения
    const [rotX, setRotX] = useState(0);
    const [rotY, setRotY] = useState(0);
    const rotRef = useRef({ x: 0, y: 0 });

    // текущая скорость для инерции
    const velocity = useRef({ x: 0, y: 0 });

    // курсор внутри?
    const inside = useRef(false);

    // tooltip
    const [tip, setTip] = useState({ show: false, text: "", x: 0, y: 0 });

    // Фильтрация тегов по сложности
    // const getFilteredTags = (tags) => {
    //     if (complexityFilter === 'all') {
    //         return tags;
    //     }

    //     return tags.filter(tag => {
    //         if (tag === 'Все') return true;
    //         const rule = rulesMap[tag];
    //         if (!rule) return true;

    //         if (complexityFilter === 'complex') {
    //             return rule.complexity === 'Сложное';
    //         } else if (complexityFilter === 'simple') {
    //             return rule.complexity === 'Не сложное';
    //         }
    //         return true;
    //     });
    // };

    // Фильтрация данных по сложности
    // const getFilteredData = (data) => {
    //     if (complexityFilter === 'all') {
    //         return data;
    //     }

    //     return data.filter(item => {
    //         if (item === 'Все') return true;
    //         const rule = rulesMap[item];
    //         if (!rule) return true;

    //         if (complexityFilter === 'complex') {
    //             return rule.complexity === 'Сложное';
    //         } else if (complexityFilter === 'simple') {
    //             return rule.complexity === 'Не сложное';
    //         }
    //         return true;
    //     });
    // };

    const tags = useMemo(() => {
        const allTags = ["Все", ...new Set(accountings.flatMap(pillar => pillar.accounting.checklist).filter(f => f))];
        return allTags;
    }, [accountings, rulesMap])

    const data = useMemo(() => {
        let allData;
        if (through) {
            allData = ["Все", ...accountingsFiltered.flatMap(pillar => pillar.accounting.checklist?.filter(ch => !pillar.accounting.checklist_elim?.success?.includes(ch)))];
        } else {
            allData = ["Все", ...accountings.flatMap(pillar => pillar.accounting.checklist)];
        }
        return allData;
    }, [accountings, accountingsFiltered, through, rulesMap])

    // количество записей по тегу
    // const counts = useMemo(() => Object.fromEntries(tags.map((t) => [t, data.filter((d) => d === t).length])), [tags, data]);
    const counts = useMemo(() => {
        const tagCounts = Object.fromEntries(tags.map((t) => [t, data.filter((d) => d === t).length]));
        // Для тега "Все" берем максимальное значение из других тегов
        if (tags.includes("Все")) {
            const maxCount = Math.max(...Object.entries(tagCounts)
                .filter(([tag]) => tag !== "Все")
                .map(([_, count]) => count));
            tagCounts["Все"] = maxCount;
        }
        return tagCounts;
    }, [tags, data]);

    // генерируем частицы один раз
    useEffect(() => {
        // console.log(counts)
        const pts = spherePoints(tags.length, window.innerWidth < 768 ? 50 : 70);
        setParticles(tags.map((t, i) => ({ tag: t, desc: descriptions[t], count: t === "Все" ? tags.filter(t => t !== "Все").reduce((acc, curr) => acc + counts[curr], 0) : counts[t] || 0, size: 10 + (counts[t] || 1) / 20, ...pts[i] })));
    }, [counts, descriptions]);

    useEffect(() => {
        toggleComplexity(complexityFilter)
    }, [complexityFilter])

    // useEffect(() => {
    //     let tmp = []
    //     if (accountingTowns && accountingTowns.length > 0) {
    //         accountingTowns.map((acc) => {
    //             acc.tps.map((tp) => {
    //                 tp.pillars.map((pillar) => {
    //                     tmp.push(pillar.accounting.checklist)
    //                 })
    //             })
    //         })

    //         tmp = tmp.flat().filter(f => f)
    //         // console.log(tmp)
    //         // setData(["Все", ...tmp])
    //         setTags(["Все", ...new Set(tmp.flat())])
    //     }
    // }, [accountingTowns]);

    // useEffect(() => {
    //     let tmp = []
    //     if (accountingTownsFiltered && accountingTownsFiltered.length > 0) {
    //         accountingTownsFiltered.map((acc) => {
    //             acc.tps.map((tp) => {
    //                 tp.pillars.map((pillar) => {
    //                     tmp.push(pillar.accounting.checklist)
    //                 })
    //             })
    //         })

    //         tmp = tmp.flat().filter(f => f)
    //         // console.log(tmp)
    //         setData(["Все", ...tmp])
    //         // setTags(["Все", ...new Set(tmp.flat())])
    //     }
    // }, [accountingTownsFiltered]);

    useEffect(() => {
        // let rules = JSON.parse(localStorage.getItem('rules'))
        if (tags.length > 0 && rules) {
            const rulesArray = rules.map(r => r.rules).flat()
            setDescriptions(Object.fromEntries(tags.map((t) => [t, t === "Все" ? "Показать все записи" : rulesArray.find(r => r.code === t)?.name])))
        }
    }, [tags]);



    // основной animation-loop
    useEffect(() => {
        let id;
        const damping = 0.95;
        const loop = () => {
            if (!inside.current) {
                // инерция
                rotRef.current.x += velocity.current.x;
                rotRef.current.y += velocity.current.y;
                velocity.current.x *= damping;
                velocity.current.y *= damping;
                setRotX(rotRef.current.x);
                setRotY(rotRef.current.y);
            }
            id = requestAnimationFrame(loop);
        };
        id = requestAnimationFrame(loop);
        return () => cancelAnimationFrame(id);
    }, []);

    useEffect(() => {
        if (selected.length > 0) {
            if (selected.length === 1 && selected[0] === "Все") {
                dispatch(setFilter({ 'checklist': null }))
            } else {
                dispatch(setFilter({ 'checklist': selected }))
            }
        }
    }, [selected])

    // обработка движения внутри контейнера
    const handleMouseMove = (e) => {
        if (!containerRef.current) return;
        const rect = containerRef.current.getBoundingClientRect();
        const cx = rect.left + rect.width / 2;
        const cy = rect.top + rect.height / 2;
        const dx = e.clientX - cx;
        const dy = e.clientY - cy;
        const radius = rect.width / 2;

        const isInside = dx * dx + dy * dy <= radius * radius;
        inside.current = isInside;

        if (isInside) {
            // относительное движение курсора
            const factor = 0.005; // чувствительность
            const deltaX = e.movementX || 0;
            const deltaY = e.movementY || 0;

            // Оставляем горизонтальное вращение как есть, инвертируем вертикальное
            rotRef.current.x += -deltaY * factor;
            rotRef.current.y += deltaX * factor;

            velocity.current.x = -deltaY * factor;
            velocity.current.y = deltaX * factor;

            setRotX(rotRef.current.x);
            setRotY(rotRef.current.y);
        }

        if (tip.show) setTip((t) => ({ ...t, x: e.clientX - 10, y: e.clientY + 20 }));
    };

    // Добавляем обработчики для тач-событий
    const handleTouchStart = (e) => {
        if (!containerRef.current) return;
        const touch = e.touches[0];
        const rect = containerRef.current.getBoundingClientRect();
        const cx = rect.left + rect.width / 2;
        const cy = rect.top + rect.height / 2;
        const dx = touch.clientX - cx;
        const dy = touch.clientY - cy;
        const radius = rect.width / 2;

        const isInside = dx * dx + dy * dy <= radius * radius;
        inside.current = isInside;

        if (isInside) {
            // Сохраняем начальную позицию тача
            containerRef.current._touchStartX = touch.clientX;
            containerRef.current._touchStartY = touch.clientY;
        }
    };

    const handleTouchMove = (e) => {
        if (!containerRef.current || !inside.current) return;
        const touch = e.touches[0];

        // Вычисляем разницу между текущей и начальной позицией
        const deltaX = touch.clientX - (containerRef.current._touchStartX || touch.clientX);
        const deltaY = touch.clientY - (containerRef.current._touchStartY || touch.clientY);

        // Обновляем начальную позицию
        containerRef.current._touchStartX = touch.clientX;
        containerRef.current._touchStartY = touch.clientY;

        // Применяем вращение с учетом чувствительности
        const factor = 0.01; // Увеличиваем чувствительность для тач-устройств
        rotRef.current.x += -deltaY * factor;
        rotRef.current.y += deltaX * factor;

        velocity.current.x = -deltaY * factor;
        velocity.current.y = deltaX * factor;

        setRotX(rotRef.current.x);
        setRotY(rotRef.current.y);
    };

    const handleTouchEnd = () => {
        inside.current = false;
    };

    // курсор покинул контейнер
    const handleMouseLeave = () => {
        inside.current = false;
        setTip((t) => ({ ...t, show: false }));
    };

    const toggleTag = (tag) => {
        if (tag === "Все") return setSelected(["Все"]);
        setSelected((prev) => {
            const next = prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev.filter((t) => t !== "Все"), tag];
            return next.length ? next : ["Все"];
        });
    };

    const toggleComplexity = (complexity) => {
        console.log(complexityFilter)
        if (complexity === "Все") return setSelected(["Все"]);
        setSelected(Object.values(rulesMap).filter(r => r.complexity === complexity).map(r => r.code));
    };



    // const visibleData = selected.includes("Все") ? props.data : props.data.filter((d) => selected.includes(d.code));

    return (
        // createPortal(
        <Box className="tag-cloud-container" sx={{
            position: 'relative',
            display: 'flex',
            alignSelf: 'end',
            justifyContent: 'right',
            width: 'fit-content',
            padding: '10px 0',
            opacity: '1',
            userSelect: 'none',
            gap: { xs: '15px', md: '30px' },
        }}>

            {/* Таблица записей */}
            <Box className="tag-cloud-list" sx={{
                position: 'relative',
                width: '40%',
                overflowY: 'auto',
                opacity: 0.9,
                '&:hover': {
                    opacity: 1,
                },
            }}>
                <Box className="tag-cloud-list-content" sx={{
                    color: 'rgb(214, 214, 214)',
                    backgroundColor: 'rgb(36, 36, 36)',
                    padding: { xs: '0.2rem', md: '0.5rem 1rem' },
                    borderRadius: '0.25rem',
                    fontSize: { xs: '0.6rem', md: '0.85rem' }
                }}>
                    Записи {selected.includes("Все") ? "(все)" : `по: ${selected.join(", ")}`}
                </Box>


            </Box>
            {/* Сфера тегов */}
            <Box
                sx={{
                    width: { xs: '150px', md: '200px' },
                    height: { xs: '150px', md: '200px' },
                    overflow: 'hidden',
                    opacity: 1

                }}
                ref={containerRef}
                className="tag-cloud-sphere"
                onMouseMove={handleMouseMove}
                onMouseLeave={handleMouseLeave}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
            >
                {particles.map((p, i) => {
                    if (p.count === 0) return null
                    const cosY = Math.cos(rotY), sinY = Math.sin(rotY), cosX = Math.cos(rotX), sinX = Math.sin(rotX);
                    let x = p.x * cosY - p.z * sinY;
                    let z = p.x * sinY + p.z * cosY;
                    let y = p.y * cosX - z * sinX;
                    z = p.y * sinX + z * cosX;
                    const scale = (window.innerWidth < 768 ? 0.4 : 1) + z / 1000;
                    const active = selected.includes("Все") || selected.includes(p.tag);
                    console.log(p)
                    return (
                        <motion.div
                            key={p.tag}
                            className="tag-cloud-tag"
                            style={{
                                left: `calc(50% + ${x}px)`,
                                top: `calc(50% + ${y}px)`,
                                fontSize: `${p.size * scale}px`,
                                zIndex: Math.floor(z + 250),
                                backgroundColor: colorOf(p.tag, active ? 1 : 0.35),
                                color: "white",
                                transform: `translate(-50%, -50%) scale(${Math.sin(Date.now() / 400 + i) * 0.1 + 1})`

                            }}
                            onClick={() => toggleTag(p.tag)}
                            onMouseEnter={(e) => setTip({ show: true, text: p.desc, x: e.clientX - 10, y: e.clientY + 20 })}
                            onMouseLeave={() => setTip((t) => ({ ...t, show: false }))}
                        >
                            <div className="tag-cloud-tag-text-container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', lineHeight: '1' }}>
                                <span className="tag-cloud-tag-text">{p.tag}</span>
                                <span className="tag-cloud-tag-count" style={{ fontSize: `${Math.max((p.size * scale) / 2, 10)}px` }}>{p.count}</span>
                            </div>
                        </motion.div>
                    );
                })}
                {tip.show && (
                    createPortal(<Box
                        sx={{
                            position: 'absolute',
                            padding: '0.3rem 0.5rem',
                            fontSize: '0.75rem',
                            backgroundColor: 'black',
                            color: 'white',
                            borderRadius: '0.25rem',
                            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
                            pointerEvents: 'none',
                            zIndex: '12000',
                            left: tip.x,
                            top: tip.y
                        }}
                        className="tag-cloud-tooltip"
                    // style={{ , zIndex: 12000 }}
                    >
                        {tip.text}
                    </Box>
                        , document.body)
                )}
            </Box>

            <Box className="tag-cloud-controls" sx={{
                display: 'flex',
                justifyContent: 'flex-start',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '5px',
                color: 'rgb(214, 214, 214)',
                backgroundColor: 'rgb(36, 36, 36)',
                padding: { xs: '0.2rem', md: '0.5rem 1rem' },
                fontSize: { xs: '0.6rem', md: '0.8rem' },
                borderRadius: '0.25rem',
                opacity: '0.9',
                width: 'fit-content',
                height: 'fit-content',
            }}>
                {/* Переключатель режима отображения */}
                <Box className="tag-cloud-type-switch" sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    padding: '2px',
                    gap: { xs: '0', md: '5px' },

                }}>
                    <Switch
                        checked={through}
                        onChange={() => setThrough(!through)}
                        size="small"
                        sx={{
                            transform: { xs: 'scale(0.8)', md: '' }
                        }}
                    />
                    <Typography sx={{ fontSize: { xs: '0.6rem', md: '0.8rem' } }}>{through ? 'Зависимая' : 'Независимая'}</Typography>

                </Box>

                {/* Фильтр по сложности */}

                <Box className="tag-cloud-filter-complexity">
                    <FormControl component="fieldset" size="small" sx={{}}>
                        {/* <FormLabel component="legend" sx={{ fontSize: { xs: '0.7rem', md: '0.8rem' }, marginBottom: '5px' }}>
                            Фильтр сложности
                        </FormLabel> */}
                        <RadioGroup
                            row
                            aria-label="complexity-filter"
                            name="complexity-filter"
                            value={complexityFilter}
                            onChange={(e) => setComplexityFilter(e.target.value)}
                            sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'end' }}
                        >
                            <FormControlLabel
                                value="Все"
                                control={<Radio size="small" sx={{
                                    padding: '1px 5px',
                                    color: 'white',
                                    '& .MuiSvgIcon-root': {
                                        fontSize: { xs: 16, md: 20 }
                                    },
                                }} />}
                                label="Все"
                                sx={{
                                    margin: 0,
                                    '& .MuiFormControlLabel-label': {
                                        whiteSpace: 'nowrap',
                                        fontSize: { xs: '0.6rem', md: '0.8rem' },

                                    }
                                }}
                            />
                            <FormControlLabel
                                value="Сложное"
                                control={<Radio size="small" sx={{
                                    padding: '1px 5px',
                                    color: 'white',
                                    '& .MuiSvgIcon-root': {
                                        fontSize: { xs: 16, md: 20 }
                                    },
                                }} />}
                                label="Сложное"
                                sx={{
                                    margin: 0,
                                    '& .MuiFormControlLabel-label': {
                                        whiteSpace: 'nowrap',
                                        fontSize: { xs: '0.6rem', md: '0.8rem' },

                                    }
                                }}
                            />
                            <FormControlLabel
                                value="Не сложное"
                                control={<Radio size="small" sx={{
                                    padding: '1px 5px',
                                    color: 'white',
                                    '& .MuiSvgIcon-root': {
                                        fontSize: { xs: 16, md: 20 },
                                    },
                                }} />}
                                label="Не сложное"
                                sx={{
                                    margin: 0,
                                    '& .MuiFormControlLabel-label': {
                                        whiteSpace: 'nowrap',
                                        fontSize: { xs: '0.6rem', md: '0.8rem' },

                                    }
                                }}
                            />
                        </RadioGroup>
                    </FormControl>
                </Box>
            </Box>


        </Box >
        // ,
        // document.body)
    );
}

const StyledTableCellSpec = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#D0D0D0',
        color: 'black',
        padding: '4px 4px',
        fontSize: 'inherit',
        fontWeight: 'bold',
        '&:hover': {
            backgroundColor: '#909090',
            cursor: 'pointer'
        },
        '@media (max-width: 768px)': {
            fontSize: 'inherit',
            padding: '1px 2px',
        }
    },
    [`&.${tableCellClasses.body}`]: {
        padding: '0px 1px',
        fontSize: 'inherit',
        lineHeight: 1.2,
        '@media (max-width: 768px)': {
            fontSize: 'inherit',
            padding: '0px 0px',
        }
    },
}));

const parseDate = (str) => {
    if (!str) return null
    const [timePart, datePart] = str.split(' ');
    const [day, month, year] = datePart.split('.').map(Number);
    const [hours, minutes] = timePart.split(':').map(Number);

    // Создаем объект Date (месяцы в JS начинаются с 0)
    return new Date(year, month - 1, day, hours, minutes);
};

const StyledTableRowSpec = styled(TableRow)(({ theme }) => ({
    backgroundColor: 'rgb(230, 230, 230)',
    maxWidth: '600px',
    '&:hover': {
        backgroundColor: 'rgb(255, 255, 255)',
        cursor: 'pointer'
    },
}));

const StatementsHistory = (props) => {
    const map = useMap();
    const dispatch = useDispatch();
    // const [isHidden, setIsHidden] = useState(window.innerWidth < 768 ? true : false)

    const [textSearch, setTextSearch] = useState('')

    const accountingNewObjectFiltered = useSelector(selectAccountingsGroupedByTownsNew)
    // const filter = useSelector(state => state.state.filter)
    const rulesMap = useSelector(selectRulesMap)

    const [accounting, setAccounting] = useState([])
    const [accountingF, setAccountingF] = useState([])


    useEffect(() => {
        let accs = []
        // const checklistFilter = filter.checklist
        // const tpFilter = filter.tp
        if (accountingNewObjectFiltered && accountingNewObjectFiltered.length > 0) {
            accountingNewObjectFiltered.map(acc => {
                // if (tpFilter && tpFilter.includes(acc.tp.fid)) return null
                acc.tps.map(tp => {
                    tp.pillars.map(p => {
                        if (p.status === 'default') return null
                        let accounting = p.accounting
                        // if (checklistFilter && (!accounting.checklist || !accounting.checklist.find(c => checklistFilter.includes(c)))) return null
                        if (accounting.checklist) {
                            accounting = { ...accounting, checklist: accounting.checklist.map(c => rulesMap[c]) }
                        }
                        accs.push({
                            tp: tp.tp,
                            accounting: accounting,
                            pillar: { ...p, accounting: null }
                        })
                    })

                })
            }).filter(f => f)

        }
        setAccounting(accs)
    }, [accountingNewObjectFiltered])



    // useEffect(() => {
    //     clearTimeout(t)
    //     setT(setTimeout(function () {
    //         dispatch(setFilter({ type: 'statements', filter: f }))

    //     }, 1000))
    // }, [f])

    useEffect(() => {
        if (textSearch && accounting) {
            let ids = new Set()
            const searchWords = textSearch.toLowerCase().split(/\s+/).filter(word => word.length > 0);
            setAccountingF(accounting.map(acc => {
                if (searchWords.every(word =>
                    [acc.pillar.name, acc.accounting.id, acc.accounting.checklist ? acc.accounting.checklist.map(c => c.code + ' | ' + c.name).join(' ') : acc.accounting.instructions, formatDate(acc.accounting.edited), acc.tp.name].join(' ').toLocaleLowerCase().includes(word.toLocaleLowerCase())
                )) return acc
            }).filter(f => f))
        } else {
            setAccountingF(accounting)
        }

    }, [accounting, textSearch])



    function selectHost(host, layer = null) {
        // console.log(host)
        if (host) {


            // if (window.innerWidth < 768) {
            //     // dispatch(setAccountingControlHidden(true))
            //     setState((p) => { return { ...p, hidden: true } })
            // }
            // map.panTo([
            //     host.x_y_coord.split(' ')[1],
            //     host.x_y_coord.split(' ')[0],
            // ], 16, { duration: 1, animate: false })
            if (host.coords) {
                map.setView(host.coords, 18, { duration: 1, animate: false })
            } else {
                map.setView([
                    host.x_y_coord.split(' ')[1],
                    host.x_y_coord.split(' ')[0],
                ], 18, { duration: 1, animate: false })
            }

            map.eachLayer(function (layer) {
                layer.closeTooltip()
            })
            dispatch(setLayers({ layer: layer, position: 1 }))
            setTimeout(() => {

                map.closePopup()
                map.eachLayer(function (layer) {
                    if (layer.options.data === host.fid) {
                        layer.openTooltip()
                        addPulseMarker(map, layer)
                    }
                })
            }, 500)
        }
    }




    return (

        createPortal(
            <div className="statements-update-control" style={{

                order: 3,
                zIndex: 1200,
                display: 'flex',
                flexDirection: 'column',
                right: 0,
                width: window.innerWidth > 768 ? '600px' : '400px',
                borderRadius: window.innerWidth > 768 ? '5px' : '3px',
                maxHeight: '250px',
                transform: window.innerWidth > 768 ? 'scale(1)' : 'scale(0.7)',
                transformOrigin: 'top right',
                pointerEvents: 'auto'
            }}>

                <Box key={"header"} style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    cursor: 'pointer',
                    // padding: '2px',
                    minHeight: window.innerWidth > 768 ? '34px' : '26px',
                    height: window.innerWidth > 768 ? '34px' : '26px',
                    color: 'rgb(83, 83, 83)',
                    backgroundColor: 'rgb(230, 230, 230)',
                    // opacity: isHover ? '1' : '0.7',
                    borderRadius: window.innerWidth > 768 ? '5px' : '3px',
                    boxShadow: '0px 2px 6px grey'
                }}>
                    <div key={"title"} style={{ marginLeft: window.innerWidth > 768 ? '5px' : '3px', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <span style={{ whiteSpace: 'nowrap' }}>История предписаний - {accountingF.length}</span>

                    </div>
                    <div key={"search"} style={{ position: 'relative', display: 'flex', alignItems: 'center', width: '50%', margin: '0 0px' }}>
                        <input type="text" id="searchInput" placeholder="Поиск" style={{ height: '60%', width: '100%', border: "1px solid #ccc", borderRadius: "4px", padding: window.innerWidth > 768 ? '2px 5px' : '1px 3px', margin: '0 10px', outline: 'none' }}
                            onChange={e => setTextSearch(e.target.value)}
                            value={textSearch}
                        />
                        {textSearch &&
                            <button className='clear-input-button' onClick={e => setTextSearch('')}>
                                <span className="material-icons" style={{ fontSize: 'inherit' }}>close</span>
                            </button>
                        }
                    </div>
                    {/* {
                        window.innerWidth < 768 ?
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', cursor: 'pointer' }}
                                onClick={() => setIsHidden(true)}
                            >

                                <ArrowForwardIosIcon style={{ fill: `black`, width: '20px', height: '20px' }} />
                            </div>
                            : null
                    } */}

                </Box>


                <div key={"body"} style={{
                    background: "white",
                    justifyContent: 'left',
                    overflowY: 'auto',
                    overflowX: 'auto',
                    color: 'rgb(214, 214, 214)',
                    scrollbarColor: 'rgb(36, 36, 36)',
                    scrollbarWidth: 'thin',
                    backgroundColor: 'none',
                    borderRadius: window.innerWidth > 768 ? '5px' : '3px',
                    pointerEvents: 'auto',
                }} className="statements-control-body">

                    {
                        accountingF && accountingF.length > 0 ?


                            <TableContainer component={Paper} >
                                <Table size="small" sx={{ maxWidth: window.innerWidth > 768 ? 600 : 450 }} aria-label="simple table">
                                    {/* <TableHead>
                                                <StyledTableRowSpec>
                                                    <StyledTableCellSpec align="center"></StyledTableCellSpec>
                                                    <StyledTableCellSpec align="center">Тип, марка, обозначение документа, опросного листа</StyledTableCellSpec>
                                                    <StyledTableCellSpec align="center">Завод изготовитель</StyledTableCellSpec>
                                                    <StyledTableCellSpec align="center">Количество</StyledTableCellSpec>
                                                    <StyledTableCellSpec align="center">Масса ед., кг.</StyledTableCellSpec>
                                                </StyledTableRowSpec>
                                            </TableHead> */}
                                    <TableBody>
                                        {
                                            [...accountingF].sort((a, b) => {

                                                return parseDate(b.accounting?.updated) - parseDate(a.accounting?.updated)
                                            }).map((acc, i) => {
                                                return (

                                                    <StyledTableRowSpec
                                                        key={i}
                                                        onClick={() => aimToObject(map, acc.pillar)}
                                                    >

                                                        <StyledTableCellSpec align="center"><UpdateIcon style={{ fill: `var(--${acc.pillar.status})` }} /></StyledTableCellSpec>
                                                        <StyledTableCellSpec align="center" title={acc.accounting.editor?.for_select || acc.accounting.editor}>{acc.accounting.edited}</StyledTableCellSpec>
                                                        <StyledTableCellSpec>
                                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
                                                                <span >{acc.pillar.name}</span>
                                                                <span style={{ color: `var(--${acc.pillar.status})` }}>id{acc.accounting.id}</span>
                                                            </div>
                                                        </StyledTableCellSpec>

                                                        <StyledTableCellSpec style={{ color: `var(--${acc.pillar.status})` }}>
                                                            {acc.accounting.checklist ?
                                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
                                                                    {
                                                                        acc.accounting.checklist.map((c, i) => {
                                                                            // console.log(c)
                                                                            return <span key={i} style={{ color: `var(--${acc.pillar.status})` }}>{c.code} | {c.name}</span>
                                                                        })
                                                                    }
                                                                </div> : <span style={{ color: `var(--${acc.pillar.status})` }}>id{acc.accounting.id} - {acc.accounting.instructions}</span>}

                                                        </StyledTableCellSpec>
                                                        <StyledTableCellSpec>{acc.tp.name}</StyledTableCellSpec>
                                                    </StyledTableRowSpec>
                                                )
                                            })
                                        }

                                    </TableBody>
                                </Table>
                            </TableContainer>

                            : null
                    }

                </div>


            </div >
            , document.getElementById("map-controls-right-top"))

    )



}

export default StatementsControl;
